<template>
  <PapeleriaRequestsList/>
</template>
<script>
import PapeleriaRequestsList from '@/components/modules/papeleria/requests/list'
export default {
  name: 'PapeleriaRequests',
  components: {
    PapeleriaRequestsList
  }
}
</script>



// WEBPACK FOOTER //
// src/views/papeleria/requests/list.vue